// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"Notification_container__2Ycj5","margin":"Notification_margin__3Okiy"};